<template>
    <v-tabs slider-color="primary" class="mb-4" style="border-bottom: 1px solid #ddd;">
        <v-tab key="TodasComprasDiretas" ripple :to="{name: 'TodasComprasDiretas'}">Todas</v-tab>
        <v-tab key="CompraDiretaEmHomologacao"
               ripple
               v-if="ehAutoridadeSuperior"
               :to="{name: 'CompraDiretaEmHomologacao'}">Em Homologação</v-tab>
    </v-tabs>
</template>

<script>
import azAuth from '@azinformatica/loki/src/utils/az-auth'

export default {
    name: 'MenuTabsTodasHomologacao',
    methods: {azAuth},
    computed: {
        ehAutoridadeSuperior() {
            return this.azAuth(this.$store.state.loki.user.authorities, ['Comprador.Autoridade.Superior'])
        }
    }
}
</script>
